module.exports = __webpack_public_path__ + "img/activity.cbbcc8fa.png";